/** @jsxImportSource @emotion/react */
import { Dropdown, MenuProps } from "antd";
import React, { useState } from "react";
import { DropdownItemButton } from "../../common/DropdownItemButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useDeleteIntegration } from "../service/integrations-api";
import { ActionSpinner } from "../../../components/ActionSpinner";
import * as authSelectors from "../../auth/authSelectors";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { css } from "@emotion/react";
import { DropdownMenuWrapper } from "../../common/DropdownMenuWrapper";
import { ellipsisStyle } from "../../menus/components/MenuDropdown";
import { useSearchParamsManipulation } from "../../../hooks/use-searchparams-manipulation";
import { getErrorMessage } from "../../../error-handler";

type Props = {
  id: string;
};

const dropdownInnerWrapper = css`
  display: flex;
  flex-direction: column;
  padding: 8px;
`;

export const IntegrationListItemDropdown = ({ id }: Props) => {
  const { setOption } = useSearchParamsManipulation();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const [open, setOpen] = useState<boolean>(false);

  const {
    mutateAsync: deleteIntegration,
    isLoading: isLoadingDeletion,
  } = useDeleteIntegration();

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <DropdownItemButton
          onClick={() => {
            setOption(id);
          }}
          icon={<FontAwesomeIcon icon={solid("pen")} />}
        >
          Edit
        </DropdownItemButton>
      ),
    },
    {
      key: "2",
      label: (
        <DropdownItemButton
          onClick={async () => {
            try {
              await deleteIntegration({ data: { id }, organizationKeyName });
              toastr.success("Success", "Integration successfully deleted");
            } catch (error: unknown) {
              const message = getErrorMessage(error);
              toastr.error("Error", message);
            }
          }}
          icon={<FontAwesomeIcon icon={solid("trash-can")} />}
        >
          {isLoadingDeletion ? <ActionSpinner /> : "Delete integration"}
        </DropdownItemButton>
      ),
    },
  ];

  return (
    <Dropdown
      menu={{
        items: items,
      }}
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      dropdownRender={(menu) => (
        <DropdownMenuWrapper>
          <div css={dropdownInnerWrapper}>
            {React.cloneElement(menu as React.ReactElement, {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                boxShadow: "none",
                padding: "0px",
                backgroundColor: "transparent",
              },
            })}
          </div>
        </DropdownMenuWrapper>
      )}
    >
      <div css={ellipsisStyle}>
        <FontAwesomeIcon icon={solid("ellipsis")} />
      </div>
    </Dropdown>
  );
};
